export default __webpack_public_path__ + "static/media/Jump (1).949f11e1.png";